(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/betslip/assets/javascripts/payment-button.js') >= 0) return;  svs.modules.push('/components/lb-ui/betslip/assets/javascripts/payment-button.js');
"use strict";


const {
  useContext,
  forwardRef
} = React;
const {
  BetslipContext
} = svs.components.lbUi.betslip;
const {
  format
} = svs.utils;
const {
  ReactButton,
  ReactIcon
} = svs.ui;
const PaymentButton = forwardRef((props, ref) => {
  const {
    accountBalance,
    price,
    errorMessage,
    onPay,
    isPayable,
    isSelfService
  } = useContext(BetslipContext);
  let payButtonLabel;
  if (isSelfService) {
    payButtonLabel = 'Lägg i varukorg';
  } else {
    payButtonLabel = "Betala ".concat(format.Currency(price), " kr");
  }
  return React.createElement("div", {
    className: "padding-1 bg-sport-100"
  }, accountBalance && !isSelfService ? React.createElement("div", {
    className: "fc-grey-700 align-center padding-bottom-1"
  }, React.createElement("span", {
    className: "padding-right"
  }, "Saldo:"), React.createElement("span", null, format.Currency(accountBalance), ' ', "kr")) : null, errorMessage ? React.createElement("div", {
    className: "align-center padding-bottom-1"
  }, React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "200"
  }), React.createElement("div", {
    className: "fc-red"
  }, errorMessage)) : null, React.createElement(ReactButton, {
    block: true,
    className: "qa-betslip-pay-btn betslip-payment-button",
    disabled: !isPayable,
    elemRef: ref,
    focus: true,
    onClick: onPay,
    size: 300
  }, payButtonLabel));
});
setGlobal('svs.components.lbUi.betslip.PaymentButton', PaymentButton);

 })(window);